import React from 'react';
import {
    Bottom,
    ButtonBlock,
    CenterBlock,
    ComputerButton,
    Content,
    Description,
    DescriptionBlock2,
    Ellipse,
    FirstColumn,
    Left,
    Minus,
    Plus,
    Right,
    SecondColumn,
    SubTitle,
    SubTitleBlock,
    Title,
    Top,
    Vertical,
} from './styled';
import { useTranslation } from 'react-i18next';
import Screen from './Screen';
import DOMPurify from 'dompurify';

const Computer = () => {
    const { t } = useTranslation('pages/home');
    return (
        <CenterBlock>
            <Ellipse />
            <Top>
                <Plus />
                <Minus width={22} />
                <Title variant="h3">{t('event')}</Title>
                <Minus className="all" />
                <Plus />
            </Top>
            <Bottom>
                <Plus />
                <Minus className="all" />
                <ButtonBlock>
                    <ComputerButton onClick={() => window.open('https://ctf.thesascon.com/')}>
                        {t('details').toUpperCase()}
                    </ComputerButton>
                </ButtonBlock>
                <Minus width={125} />
                <Plus />
            </Bottom>
            <Left>
                <Vertical />
            </Left>
            <Right>
                <Vertical />
            </Right>
            <Content>
                <FirstColumn>
                    <SubTitleBlock>
                        <SubTitle>{t('ctf')}</SubTitle>
                    </SubTitleBlock>
                    <DescriptionBlock2>
                        <Description variant="p1" color="textDisabled">
                            <span
                                className="purple"
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(t('ctf-chapter-time')),
                                }}
                            />
                        </Description>
                    </DescriptionBlock2>
                    <DescriptionBlock2>
                        <Description variant="p1" color="textDisabled">
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(t('ctf-chapter1')),
                                }}
                            />
                        </Description>
                    </DescriptionBlock2>
                    <DescriptionBlock2>
                        <Description variant="p1" color="textDisabled">
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(t('ctf-chapter2')),
                                }}
                            />
                        </Description>
                    </DescriptionBlock2>
                    <DescriptionBlock2>
                        <Description variant="p1" color="textDisabled">
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(t('ctf-chapter3')),
                                }}
                            />
                        </Description>
                    </DescriptionBlock2>
                    <DescriptionBlock2>
                        <Description variant="p1" color="textDisabled">
                            <span
                                className={'nowrap'}
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(t('ctf-chapter4')),
                                }}
                            />
                        </Description>
                    </DescriptionBlock2>
                </FirstColumn>
                <SecondColumn>
                    <Screen />
                </SecondColumn>
            </Content>
        </CenterBlock>
    );
};

export default Computer;
